import { Tab as RaTab, TabProps as RaTabProps } from 'react-admin';

export type TabProps = RaTabProps;

export const Tab = RaTab;
